import { secureGetItem, STORAGE_KEYS } from "./secureStorage";
import { handleError } from "./errorHandling";

/**
 * Gets the running task ID from Redux or localStorage
 * @param {Object} timerRedux - Redux timer state
 * @returns {string|null} Running task ID or null
 */
export const getRunningTaskFromStorage = (timerRedux) => {
  try {
    if (timerRedux?.runningTask) {
      return timerRedux.runningTask;
    }
    return secureGetItem(STORAGE_KEYS.RUNNING_TASK, null);
  } catch (e) {
    handleError(e, "reading running task", { action: "Reading timer data" });
    return null;
  }
};
